<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'acouteCost-masterdata-page',
};

</script>
